"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.temperatureToKelvin = void 0;
const TemperatureUnit_1 = require("./TemperatureUnit");
function temperatureToKelvin(temperature, inUnit) {
    switch (inUnit) {
        case TemperatureUnit_1.TemperatureUnit.Celsius:
            return temperature + 273.15;
        case TemperatureUnit_1.TemperatureUnit.Fahrenheit:
            return ((temperature + 459.76) * 5) / 9;
        case TemperatureUnit_1.TemperatureUnit.kelvin:
            return temperature;
    }
}
exports.temperatureToKelvin = temperatureToKelvin;
//# sourceMappingURL=temperatureToKelvin.js.map